import n from "@fond-of/api-client";
const o = async (t, a, e = {}) => await t.post("customer-satisfaction", {
  ...e,
  json: {
    records: a,
    typecast: !0
  }
}), c = (t, a, e = {}) => t.post("media-files", {
  ...e,
  language: !1,
  auth: !1,
  fondOfInternal: !1,
  beta: !1,
  canary: !1,
  json: {
    data: {
      type: "media-files",
      attributes: {
        mimeType: a
      }
    }
  }
}).json(), i = (t, a, e = {}) => t.post("newsletter", {
  ...e,
  json: a
}), l = async (t, a, e = {}) => await t.post("return-label", {
  ...e,
  json: a
}).text(), u = async (t, a, e = {}) => await t.post("return-reason", {
  ...e,
  json: {
    records: a,
    typecast: !0
  }
}), p = {
  new: (t, a) => {
    const e = n.new({
      deserialize: !0,
      ...a,
      prefixUrl: t
    });
    return e.subscribeNewsletter = (s, r = {}) => i(e, s, r), e.createReturnLabel = (s, r = {}) => l(e, s, r), e.createReturnReason = (s, r = {}) => u(e, s, r), e.createMediaFile = (s, r = {}) => c(e, s, r), e.createCustomerSatisfaction = (s, r = {}) => o(e, s, r), e;
  }
};
export {
  p as default
};
//# sourceMappingURL=brand-api.js.map
